import React from "react";
import { Button, Paper } from "@mhome/ui";
import { useComponentBackgroundColor } from "../common/adaptive-theme-provider";
import Markdown from "../common/markdown";

const InfoContentView = ({ integrationData, location, history }) => {
  // Get the background color function with current global state
  const getComponentBgColor = useComponentBackgroundColor();

  const handleLocationSettings = () => {
    history.replace("/space");
  };

  const handlePhonePermissionSettings = () => {
    history.push("/phone/setting");
  };

  // Common Paper styling that automatically adapts to theme
  const paperStyle = {
    padding: "16px",
    backgroundColor: getComponentBgColor("hsl(var(--card))"),
  };

  const infoContent = {
    "basic.automation": (
      <div className="flex flex-col gap-4">
        <Paper elevation={0} style={paperStyle}>
          <Markdown>
            {`System default integration. It can provide automation status and control the automations.

- Immediately run a task-flow automation
- Enable / disable a recurring automation
- Check automation running status
- Check automation enable / disable status`}
          </Markdown>
        </Paper>
      </div>
    ),
    "basic.notification": (
      <div className="flex flex-col gap-4">
        <Paper elevation={0} style={paperStyle}>
          <Markdown>
            {`System default integration. It's to send App notification messages.

- Send notification messages to the App
- Send notification with interactive input dialog for user response`}
          </Markdown>
        </Paper>
      </div>
    ),
    "basic.widget": (
      <div className="flex flex-col gap-4">
        <Paper elevation={0} style={paperStyle}>
          <Markdown>
            {`System default integration. It provides capabilities related to the widget management.

Widget is a customizable dashboard component that hold arbitrary user defined data. Two types of widgets:

- **Data widget**: The widget is displayed as an input component. User can set and view the data value. It can be used to hold space global state data, like home/away state.
- **Button widget**: The widget is a UI button. Clicking the button will emit events. It can be used as automation trigger.

**Capabilities:**
- Change data widget value
- Provide data widget value
- Provide button widget event`}
          </Markdown>
        </Paper>
      </div>
    ),
    "basic.time": (
      <div className="flex flex-col gap-4">
        <Paper elevation={0} style={paperStyle}>
          <Markdown>
            {`This integration provides all time related capabilities. It's automatically managed by the system.

Time & schedule are always binded to the location. Home location is the default, but you can set schedules for other locations.`}
          </Markdown>
          <Button
            variant="contained"
            color="primary"
            onClick={handleLocationSettings}
            className="mt-4"
            style={{ boxShadow: "none", textTransform: "none" }}
          >
            Location Settings
          </Button>
        </Paper>
      </div>
    ),
    "basic.phone": (
      <div className="flex flex-col gap-4">
        <Paper elevation={0} style={paperStyle}>
          <Markdown>
            {`On Android / iOS App, go to "Menu -> Phone Setting" to connect your phone and grant the access.`}
          </Markdown>
          <Button
            variant="contained"
            color="primary"
            onClick={handlePhonePermissionSettings}
            className="mt-4"
            style={{ boxShadow: "none", textTransform: "none" }}
          >
            Phone Permission Settings
          </Button>
        </Paper>
      </div>
    ),
    "basic.chat": (
      <div className="flex flex-col gap-4">
        <Paper elevation={0} style={paperStyle}>
          <Markdown>
            {`Default integration for chat. Supported capabilities:

- Listens a quick-command entered in the chat. This is usually used as automation trigger. Example: 'When I say "good night", turn off bedroom lights.'`}
          </Markdown>
        </Paper>
      </div>
    ),
    "basic.weather": (
      <div className="flex flex-col gap-4">
        <Paper elevation={0} style={paperStyle}>
          <Markdown>
            {`Provide weather data. Location is required. Select your weather data provider to start.

- Provide current weather. Refresh every ~30 minutes. Different providers may vary.
- Provide daily forecast.
- Weather data includes temperature, feels like temperature, humidity, cloud cover, UV index, condition, etc.`}
          </Markdown>
          <Button
            variant="contained"
            color="primary"
            onClick={handleLocationSettings}
            className="mt-4"
            style={{ boxShadow: "none", textTransform: "none" }}
          >
            Location Settings
          </Button>
        </Paper>
      </div>
    ),
    "basic.device": (
      <div className="flex flex-col gap-4">
        <Paper elevation={0} style={paperStyle}>
          <Markdown>
            {`Connect any device providers to get started.

- Auto-installed when any provider is connected.
- Auto-uninstalled when no available provider connections.`}
          </Markdown>
        </Paper>
      </div>
    ),
  };

  return infoContent[integrationData.integration] || null;
};

export default InfoContentView;
